import React from 'react';
import '../Stlye.css'; // Make sure to import your CSS file
import { NavLink } from 'react-router-dom';
import dataconsulting from '../images/data-consulting.webp'
import angelinvestor from '../images/angel_investor1.webp'
import HospitalityOperations from '../images/hospitality.jpg'
import ManagementConsulting from '../images/management_consulting_banner.jpg'
import databanner from '../images/data-banner.webp'
import MetaTags from '../MetaTags';
import bg from '../images/bg-page-title.webp'
function OurOperations() {
  return (
    <>
    <div>
    <MetaTags
        title="Our Operations | Smart Resources QLD"
        description="Explore how Smart Resources QLD delivers innovative solutions in synthetic data, angel investment, hospitality, management consulting, and software development across Queensland."
        Canonical="https://smartresourcesqld.com.au/operations"
        DCTitle="Our Operations | Smart Resources QLD"
        DCDescription="Explore how Smart Resources QLD delivers innovative solutions in synthetic data, angel investment, hospitality, management consulting, and software development across Queensland."
        DCSubject="Innovation, Sustainability and Growth Solutions"
        ogImage={bg}
        ogTitle="Our Operations | Smart Resources QLD"
        ogDescription="Explore how Smart Resources QLD delivers innovative solutions in synthetic data, angel investment, hospitality, management consulting, and software development across Queensland."
        ogUrl="https://smartresourcesqld.com.au/operations"
      />
        <section className="innr_banner"  style={{ 
  backgroundImage: `url(${bg})` }}>
          <div className="page_title_innr">
            <div className="page_title">Our Operations</div>
            <ul className="bread_crumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li>Operations</li>
            </ul>
          </div>
        </section>
        <section className="pricing">
        <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12" data-aos="fade-right">
                        <div className="global_left">
                        <div className="global_label_top">
                            Our Operations 
                        </div>
                        <h1> We position our clients at the forefront of their field by advancing an agenda </h1>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12" data-aos="fade-left">
                        <div className="global_right pt-5">
                             <p>Explore our comprehensive range of services designed to meet your business needs and drive success across various industries. From privacy-preserving data services to corporate investments, our diverse expertise ensures tailored solutions for every aspect of your operations. Partner with us to unlock new opportunities and achieve sustainable growth for your business.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4" data-aos="fade-up">
                        <div className="realestate operations grid-item-inner wow fadeIn">
                            <label className="grid-item-over">
                                <div className="item--featured"> 
                                    <img className="disable-lazy no-lazyload " src= {dataconsulting} width="98%" height="410" alt=''/>
                                </div>
                                <div className="real_estate_consulting item--holder1">
                                    <h4>Data Science Services</h4>
                                    <div className="item--gap"></div>
                                    <p>Smart Resources QLD provides professional data science services to organisations across Australia. We help businesses build data science capabilities including forecasting models, machine learning systems, data engineering pipelines, and business intelligence dashboards.</p>
                                </div>

                                <div className="item--meta1">
                                    <h3 className="item--title1"> 
                                        <NavLink to="/operations/data-science-services-australia" onClick={() => window.scrollTo(0, 0)}>Data Science Services</NavLink></h3>
                                        <div className="item--readmore"> 
                                            <NavLink className="more-plus" onClick={() => window.scrollTo(0, 0)} to="/operations/data-science-services-australia">+</NavLink>
                                        </div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4" data-aos="fade-up">
                        <div className="realestate operations grid-item-inner wow fadeIn">
                            <label className="grid-item-over">
                                <div className="item--featured"> 
                                    <img className="disable-lazy no-lazyload " src={angelinvestor} width="98%" height="410" alt=''/>
                                </div>
                                <div className="real_estate_consulting item--holder1">
                                    <h4>Angel Investor</h4>
                                    <div className="item--gap"></div>
                                    <p>Are you an entrepreneur with a groundbreaking idea, seeking the fuel to propel it to success? Or perhaps you're an investor looking to support innovation while seeking lucrative opportunities? At [Your Angel Investor Service Name], we bridge the gap between visionary entrepreneurs and savvy investors, fostering a thriving ecosystem of innovation and growth.</p>
                                </div>

                                <div className="item--meta1">
                                    <h3 className="item--title1"> 
                                        <NavLink to="/operations/angel-investor" onClick={() => window.scrollTo(0, 0)}>Angel Investor</NavLink></h3>
                                        <div className="item--readmore"> 
                                            <NavLink className="more-plus" to="/operations/angel-investor" onClick={() => window.scrollTo(0, 0)}>+</NavLink>
                                        </div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4" data-aos="fade-up">
                        <div className="realestate operations grid-item-inner wow fadeIn">
                            <label className="grid-item-over">
                                <div className="item--featured"> 
                                    <img className="disable-lazy no-lazyload " src={HospitalityOperations} width="98%" height="410" alt='Hospitality Operations'/>
                                </div>
                                <div className="real_estate_consulting item--holder1">
                                    <h4>Hospitality Operations</h4>
                                    <div className="item--gap"></div>
                                    <p>Smart Resources QLD is involved in hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on customer service, operational coordination, service quality, and long-term sustainability.</p>
                                </div>

                                <div className="item--meta1">
                                    <h3 className="item--title1"> 
                                        <NavLink to="/operations/hospitality" onClick={() => window.scrollTo(0, 0)}>Hospitality Operations</NavLink></h3>
                                        <div className="item--readmore"> 
                                            <NavLink className="more-plus" to="/operations/hospitality" onClick={() => window.scrollTo(0, 0)}>+</NavLink>
                                        </div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4" data-aos="fade-up">
                        <div className="realestate operations grid-item-inner wow fadeIn">
                            <label className="grid-item-over">
                                <div className="item--featured"> 
                                    <img className="disable-lazy no-lazyload " src={ManagementConsulting} width="98%" height="410" alt='Management Consulting'/>
                                </div>
                                <div className="real_estate_consulting item--holder1">
                                    <h4>Management Consulting</h4>
                                    <div className="item--gap"></div>
                                    <p>Smart Resources QLD provides management consulting services focused on business planning, strategic forecasting, process improvement, workflow management, financial operations support, and long-term business growth.</p>
                                </div>

                                <div className="item--meta1">
                                    <h3 className="item--title1"> 
                                        <NavLink to="/operations/management-consulting" onClick={() => window.scrollTo(0, 0)}>Management Consulting</NavLink></h3>
                                        <div className="item--readmore"> 
                                            <NavLink className="more-plus" to="/operations/management-consulting" onClick={() => window.scrollTo(0, 0)}>+</NavLink>
                                        </div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4" data-aos="fade-up">
                        <div className="realestate operations grid-item-inner wow fadeIn">
                            <label className="grid-item-over">
                                <div className="item--featured"> 
                                    <img className="disable-lazy no-lazyload " src={databanner} width="98%" height="410" alt='Software & Web Development'/>
                                </div>
                                <div className="real_estate_consulting item--holder1">
                                    <h4>Software & Web Development</h4>
                                    <div className="item--gap"></div>
                                    <p>Smart Resources QLD provides professional software and web development services in Queensland. We help businesses design, build, and maintain tailored, scalable software systems and responsive, user-friendly websites designed to meet unique operational needs.</p>
                                </div>

                                <div className="item--meta1">
                                    <h3 className="item--title1"> 
                                        <NavLink to="/operations/software-web-development" onClick={() => window.scrollTo(0, 0)}>Software & Web Development</NavLink></h3>
                                        <div className="item--readmore"> 
                                            <NavLink className="more-plus" to="/operations/software-web-development" onClick={() => window.scrollTo(0, 0)}>+</NavLink>
                                        </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer className="footer">
          {/* Footer content */}
        </footer>
      </div>
    </>
  );
}

export default OurOperations;
